module.exports = __webpack_public_path__ + "img/8.6e7400b8.jpg";